import { Col, Row } from "antd";
import { useNavigate } from "react-router";
import { StatCard } from "../../../components/StatCard";

import { CheckCircleOutlined, DollarOutlined, ProjectOutlined } from "@ant-design/icons";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { formatCurrency } from "../../../utils/formatCurrency";

export default function StatusCards({ overview }) {
    const navigate = useNavigate();
    const cardStyle = {
        minHeight: 110,
        width: "100%",
        borderRadius: 12,
        border: "1px solid #edf0f2",
        background: "#ffffff",
        cursor: "default",
    };
    const labelStyle = { marginTop: -10, fontSize: 12,fontWeight:700, color: "#94a3b8" };

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} sm={12} md={6} lg={6}>
                <StatCard
                    title="Total Projects"
                    value={overview?.totalProjects || 0}
                    valueStyle={{ fontSize: 25, fontWeight: 700, color: "#3c3c3e" }}
                    icon={<ProjectOutlined style={{ color: "#1677ff" }} />}
                    iconBg="#e6f4ff"
                    titleStyle={labelStyle}
                    style={cardStyle}
                />
            </Col>

            <Col xs={24} sm={12} md={6} lg={6}>
                <StatCard
                    title="Active Projects"
                    value={overview?.activeProjects || 0}
                    valueStyle={{ fontSize: 25, fontWeight: 700, color: "#3c3c3e" }}
                    icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
                    iconBg="#f6ffed"
                    titleStyle={labelStyle}
                    style={cardStyle}
                />
            </Col>

            <Col xs={24} sm={12} md={6} lg={6}>
                <StatCard
                    title="TCV"
                    value={formatCurrency(overview?.totalContract || 0)}
                    valueStyle={{ fontSize: 22, fontWeight: 700, color: "#3c3c3e" }}
                    icon={<DollarOutlined style={{ color: "#FABB02", fontSize: "22px" }} />}
                    iconBg="#fffbe6"
                    titleStyle={labelStyle}
                    style={cardStyle}
                />
            </Col>

            <Col xs={24} sm={12} md={6} lg={6}>
                <div onClick={() => navigate("/watchtower/leadership-attention")} style={{ cursor: "pointer" }}>
                    <StatCard
                        title="Leadership Attention"
                        value={overview?.leadershipAttentionProjects || 0}
                        subtitleStyle={{ fontSize: 13, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        valueStyle={{ fontSize: 25, fontWeight: 700, color: "#3c3c3e" }}
                        icon={<PriorityHighIcon style={{ color: "#db0909" }} />}
                        iconBg="#fff1f0"
                        titleStyle={labelStyle}
                        style={{ ...cardStyle, cursor: "pointer" }}
                    />
                </div>
            </Col>
        </Row>
    )
}